<template>
<nav class="nav" :class="{transparent: transparent}">
  <div class="container">
    <div class="nav-left">
      <logo
        class="nav-item"
        :class="{transparent: transparent}"
        :title1="dateConIsBefore ? dateCon : dateTraining"
        :title3="'地址：' + (info.address.name || '')"
        :title4="'热线：' + (phone || '')"
        :link="'/'"></logo>
        <!-- :title2="dateConIsBefore ? dateTraining : dateCon" -->
    </div>
    <div class="nav-right">
      <div class="menu">
        <template v-for="(menu, index) in $store.state.info.menus">
          <div :key="index">
            <router-link
            v-if="!isOutlink(menu.link)"
            class="nav-item"
            :to="menu.link">{{menu.name}}</router-link>
            <a v-else class="nav-item" :href="menu.link" target="_blank">{{menu.name}}</a>
          </div>
        </template>
      </div>

      <router-link
        class="nav-item apply-pc"
        v-if="!isOutlink($store.state.info.btnApply.link)"
        :to="$store.state.info.btnApply.link">
        <button-apply :data="$store.state.info.btnApply" :price="$store.state.info.price"></button-apply>
      </router-link>
      <a
        class="nav-item apply-pc"
        v-else
        :href="$store.state.info.btnApply.link" target="_blank">
        <button-apply :data="$store.state.info.btnApply" :price="$store.state.info.price"></button-apply>
      </a>

      <router-link
        class="nav-item apply-m"
        v-if="!isOutlink($store.state.info.btnApply.link)"
        :to="$store.state.info.btnApply.link">
        <button-apply-m :data="$store.state.info.btnApply" :price="$store.state.info.price"></button-apply-m>
      </router-link>
      <a
        class="nav-item apply-m"
        v-else
        :href="$store.state.info.btnApply.link" target="_blank">
        <button-apply-m :data="$store.state.info.btnApply" :price="$store.state.info.price"></button-apply-m>
      </a>

      <div class="nav-item btn-menu"><a class="icon-menu" @click="showMenu=!showMenu"></a></div>
      <div class="menu-m" v-show="showMenu">
        <ul class="navLis" id="toggle">
          <li
            v-for="(menu, index) in $store.state.info.menus"
            :key="index"
            @click="to(menu.link)">
            {{menu.name}}</li>
        </ul>
        <div class="navCont">
          <!-- <p>时间：{{info.date}}</p> -->
          <p>大会演讲：{{info.date}}</p>
          <p>地点：{{info.address.name}}</p>
          <p>购票电话：{{contacts | filterContacts('book')}}</p>
        </div>
        <h6 class="botTit">{{info.name}}</h6>
      </div>
    </div>
  </div>
</nav>
</template>

<script>
import ButtonApply from './button'
import ButtonApplyM from './button-m'
import Logo from './logo'
import moment from 'moment'

export default {
  name: 'ConNav',
  components: {
    ButtonApply,
    ButtonApplyM,
    Logo
  },
  props: [
    'info',
    'logoImg'
  ],
  data () {
    return {
      showMenu: false,
      scrollTop: 0
    }
  },
  computed: {
    route () {
      return this.$route.name === 'home' ? 'transparent' : 'common'
    },
    transparent () {
      return this.scrollTop < 150 && this.route === 'transparent'
    },
    dateConIsBefore () {
      let beginTime = Date.parse(this.info.beginTime)
      let beginTrainingTime = Date.parse(this.info.beginTimeTraining)
      return beginTime < beginTrainingTime
    },
    dateCon () {
      if (!this.info.beginTime) return '会议：'
      let beginTime = moment(this.info.beginTime).utcOffset('+08:00')
      let endTime = moment(this.info.endTime).utcOffset('+08:00')
      return `会议：${beginTime.format('YYYY年MM月DD')}-${endTime.format('DD日')}`
    },
    dateTraining () {
      if (!this.info.beginTimeTraining) return '培训：'
      let beginTime = moment(this.info.beginTimeTraining).utcOffset('+08:00')
      let endTime = moment(this.info.endTimeTraining).utcOffset('+08:00')
      return `培训：${beginTime.format('YYYY年MM月DD')}-${endTime.format('DD日')}`
    },
    contacts () {
      return this.$store.state.info.contacts
    },
    phone () {
      let contacts = this.$store.state.info.contacts
      let phone = contacts.filter((item) => item.key === 'book')
      return phone.length ? phone[0].value : ''
    }
  },
  mounted () {
  },
  created () {
    window.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    })
  },
  beforeDestroy () {
  },
  methods: {
    to (path) {
      this.showMenu = false
      if (!this.isOutlink(path)) {
        this.$router.replace(path)
      } else {
        window.location.href = path
      }
    },
    isOutlink (url) {
      if (!url) return true
      return url.indexOf('http') === 0
    }
  },
  filters: {
    filterContacts (contacts, key) {
      for (let i in contacts) {
        if (contacts[i].key === key) return contacts[i].value
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../../assets/style/variable.sass"

$colorText: #464646
// pc
.nav
  position: fixed
  left: 0
  top: 0
  // right: 0
  width: 100%
  height: $nav-height
  display: flex
  justify-content: space-between
  background-color: $white
  z-index: 1000
  box-shadow: 0 2px 3px rgba($black, 0.1)
  transition: all $speed ease-in-out
  & > .container
    display: flex
    justify-content: space-between
  .nav-left,
  .nav-right
    display: flex
    flex-grow: 0
    flex-shrink: 0
    white-space: nowrap
  .menu
    display: flex
    line-height: 80px
    a
      font-weight: 700
      margin-right: 20px
      color: $colorText
      &:hover
        color: #0078d2
  .nav-item
    display: flex
    align-items: center
    flex-grow: 0
    flex-shrink: 0
  .icon-menu
    margin-left: 10px
    display: inline-block
    width: 24px
    height: 22px
    padding: 5px 0
    display: block
    border-top: 4px solid #696465
    border-bottom: 4px solid #696465
    &::after
      content: ''
      display: block
      width: 100%
      height: 4px
      background-color: #696465
  .menu-m
    overflow: auto
    position: fixed
    width: 100%
    top: $nav-height
    left: 0
    bottom: 0
    width: 100%
    padding: 4vw 8vw
    background-color: #efefef
    ul
      li
        width: 100%
        padding: 18px 0
        font-size: 16px
        border-bottom: 1px solid #dcdcdc
        line-height: 1
        .mar
          margin-right: 18px
        a
          display: block
          color: #595757
          &:hover
            color: #1f63af
            .icon-forward::before
              color: #1f63af
    .navLis
      .icon-home::before
        font-size: 24px
      h5
        display: inline-block
        margin-left: 18px
        font-size: 18px
      .icon-forward::before
        float: right
        font-size: 12px
        color: #b5b5b6
        vertical-align: middle
        display: inline-block
        margin-top: 8px
    .navCont
      margin-top: 24px
      margin-bottom: 24px
      font-size: 13px
      color: #898989
      p
        margin-top: 8px
    .botTit
      font-size: 13px
      color: #898989
  +mobile
    .menu, .apply-pc
      display: none
  +tablet
    height: $nav-height-pc
    .btn-menu, .apply-m, .menu-m
      display: none
    &.transparent
      background-color: transparent
      height: $nav-height-pc + 20px
      box-shadow: none
      .menu a
        font-weight: 700
        color: $white
        &:hover
          color: #0078d2
</style>
